<div
  class="modal-dialog modal-dialog-centered modal-lg cx-image-zoom-dialog"
  role="dialog"
  (esc)="close('Escape clicked')"
  [cxFocus]="focusConfig"
  [attr.aria-label]="'productImageZoomDialog.zoomedInImage' | cxTranslate"
>
  <div class="modal-content cx-dialog-content">
    <div class="modal-header cx-dialog-header">
      <button
        type="button"
        class="close"
        title="{{ 'productImageZoomDialog.close' | cxTranslate }}"
        [attr.aria-label]="'productImageZoomDialog.close' | cxTranslate"
        (click)="close('cross click')"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconType.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <div class="modal-body cx-dialog-body">
      <gen-product-image-zoom-view [galleryIndex]="galleryIndex"></gen-product-image-zoom-view>
    </div>
  </div>
</div>